import { render } from "./post-smtp-dashboard.vue?vue&type=template&id=dd15bc6c&scoped=true"
import script from "./post-smtp-dashboard.vue?vue&type=script&lang=js"
export * from "./post-smtp-dashboard.vue?vue&type=script&lang=js"

import "./post-smtp-dashboard.vue?vue&type=style&index=0&id=dd15bc6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd15bc6c"],['__file',"src/components/post-smtp-dashboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd15bc6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd15bc6c', __exports__)) {
    api.reload('dd15bc6c', __exports__)
  }
  
  module.hot.accept("./post-smtp-dashboard.vue?vue&type=template&id=dd15bc6c&scoped=true", () => {
    api.rerender('dd15bc6c', render)
  })

}


export default __exports__